<template>
    <Head :title="'About Gina Betbeze – St. Johns County Real Estate Agent'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/about" />
        <meta name="description" content="Learn about Gina Betbeze, St. Johns County real estate agent at RE/MAX Specialists. Expert in Julington Creek, offering personalized service for all your real estate needs." />
    </Head>
    <!-- Simple Blurb -->

    <PageContent
        :id="'about-page'"
        :breadcrumbs="['Home', 'About']"
        :header="'Your Realtor'"
    >
        <div class="w-full flex flex-wrap flex-col-reverse tablet-sm:flex-row">
            <div class="w-full tablet-sm:w-1/2">
                <div class="min-w-0 text-base leading-7 text-slate-700 w-full mt-0">
                    <Paragraph>
                        <strong>I have been a licensed Realtor for over 20 years and have closed over $110 million in
                        real estate sales.</strong> I live on the  border of NW St. Johns
                        and Duval County. I have received extensive training and experience in handling
                        relocation sales for my clients as well as my own family. Previously I lived in South
                        Florida and Massachusetts. I have been heavily involved in various clubs at San Juan Del
                        Rio Church, I have volunteered in the St. Johns County schools, and play league tennis
                        and pickleball throughout Jacksonville. My family and I have lived in St. Johns County
                        since 2001 where my children attended the awesome St. Johns County Schools and played on
                        various Soccer teams in the area. Living in Julington Creek Plantation for over 23 years
                        has given me tremendous insight to this community.
                    </Paragraph>

                    <SecondaryHeader>Experience</SecondaryHeader>

                    <div class="pl-1 tablet-sm:pl-8 mt-2">
                        <div class="flex items-center">
                            <span class="hidden tablet-sm:block w-2 h-2 bg-accent rounded-full mr-2"></span>
                            <span>20+ Years</span>
                        </div>
                        <div class="flex items-center">
                            <span class="hidden tablet-sm:block w-2 h-2 bg-accent rounded-full mr-2"></span>
                            <span class="text-sm tablet-sm:text-base">Duval County, St. Johns, and
                                                                      Clay County</span>
                        </div>
                        <div class="flex items-center">
                            <span class="hidden tablet-sm:block w-2 h-2 bg-accent rounded-full mr-2"></span>
                            <span class="text-sm tablet-sm:text-base">New Construction</span>
                        </div>
                        <div class="flex items-center">
                            <span class="hidden tablet-sm:block w-2 h-2 bg-accent rounded-full mr-2"></span>
                            <span>Relocation</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full tablet-sm:w-1/2 pl-1 tablet-sm:pl-8 flex items-start justify-end">
                <div class="flex flex-wrap justify-center mx-auto">
                    <img
                        id="about-page-portrait"
                        src="/images/theme/about/gina-about.webp"
                        alt="Gina Betbeze Portrait"
                        class="w-full border-4 border-accent my-4"
                    />
                </div>
            </div>
        </div>
    </PageContent>
</template>
<script setup>
import PageContent from "../Components/Layout/PageContent.vue";
import HomeLayout from "../Layouts/HomeLayout.vue";
import Breadcrumbs from "../Components/PageContent/Breadcrumbs.vue";
import Paragraph from "../Components/PageContent/Paragraph.vue"
import MainHead from "@/Components/PageContent/MainHead.vue";
import SecondaryHeader from "@/Components/PageContent/SecondaryHeader.vue";
import { Head, Link, usePage } from "@inertiajs/vue3";

defineOptions({ layout: HomeLayout });
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>
